import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import classNames from 'classnames';

import './RMLink.scss';

/**
 * @param {string} href
 * @param {'small' | 'base' | 'large'} size
 * @param {'primaryBlue' | 'secondary'} color
 * @param {boolean} bold
 */
export const RMLink = ({ href, text, children, size = 'base', color = 'primary', bold = true, className, ...rest }) => {
    const classes = classNames(
        'rm-link',
        {
            small: size === 'small',
            base: size === 'base',
            large: size === 'large',
            primary: color === 'primary',
            secondary: color === 'secondary',
            bold,
        },
        className,
    );

    return (
        <RouterLink to={href} className={classes} {...rest}>
            {children ?? text}
        </RouterLink>
    );
};
